<template>
  <ArlaNavbar />

  <section class="hero do-good-page">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column has-text-centered">
            <div v-if="!this.$store.getters.getIsSubmitted">
              <form @submit.prevent="submitForm">
                <div class="column is-12 has-text-left" v-for="(q, index) in getQuestionnaireForm.questions"
                  :key="q.id">
                  <p v-if="q.question_type === 'scale'" class="arlainterface-regular font-18 mt-4 mb-3">{{ index + 1 }}. {{
                    q.text }} </p>
                  <p v-else-if="q.question_type === 'multiple'" class="arlainterface-regular font-18 mt-4 mb-3">
                    {{ index + 1 }}. {{ q.text }} </p>
                  <p v-else class="arlainterface-regular font-18 mt-4 mb-3">{{ index + 1 }}. {{ q.text }}</p>

                  <span v-if="q.required" class="has-text-danger">(pakollinen kysymys)</span>

                  <figure v-if="index == 0" id="arla-product-question-picture" class="image">
                    <img src="../assets/img/Group47@2x.png" />
                  </figure>

                  <div v-if="q.question_type === 'yesno'" class="flex gap-4">
                    <div class="control">
                      <label class="radio arla-radio is-block ml-0 mb-3">
                        <input type="radio" :name="'q' + q.id" value="true" v-model="answers[q.id]" class="mr-2" />
                        Kyllä
                      </label>
                      <label class="radio arla-radio is-block ml-0 mb-3">
                        <input type="radio" :name="'q' + q.id" value="false" v-model="answers[q.id]" class="mr-2" /> Ei
                      </label>
                    </div>
                  </div>

                  <div v-else-if="q.question_type === 'scale'" class="flex gap-2">
                    <div class="control">
                      <label v-for="n in 5" :key="n" class="radio arla-radio is-block ml-0 mb-3">
                        <input type="radio" :name="'q' + q.id" :value="n" v-model="answers[q.id]" class="mr-2" />
                        <span v-if="n == 1">{{ n }}. Erittäin tyytymätön</span>
                        <span v-if="n == 2">{{ n }}. Vähemmän tyytyväinen</span>
                        <span v-if="n == 3">{{ n }}. Tyytyväinen</span>
                        <span v-if="n == 4">{{ n }}. Hyvin tyytyväinen</span>
                        <span v-if="n == 5">{{ n }}. Erittäin tyytyväinen</span>
                      </label>
                    </div>
                  </div>

                  <div v-else-if="q.question_type === 'text'">
                    <div class="control">
                      <textarea v-model="answers[q.id]" class="w-full border rounded p-2"
                        placeholder="Kirjoita vastauksesi..." style="resize: none; width: 100%; height: 150px;" />
                    </div>
                  </div>

                  <div v-else-if="q.question_type === 'multiple' && q.text === 'Asuinpaikka'"
                    class="flex flex-col gap-2">
                    <div class="control">
                      <select v-model="selectedTown" @change="onOptionChange(q, answers[q.id], $event)"
                        class="border rounded p-2">
                        <option disabled value="">Valitse</option>

                        <option v-for="(opt, index) in q.options" :key="opt.id" :value="opt.id">
                          {{ opt.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div v-else-if="q.question_type === 'multiple'" class="flex flex-col gap-2">
                    <div class="control">
                      <label v-for="(opt, index) in q.options" :key="opt.id"
                        :class="q.allows_multiple ? 'arla-checkbox is-block ml-0 mb-3' : 'arla-radio is-block ml-0 mb-3'">
                        <input :type="q.allows_multiple ? 'checkbox' : 'radio'" :value="opt.id" :checked="Array.isArray(answers[q.id])
                          ? (q.allows_multiple ? answers[q.id].includes(opt.id) : answers[q.id][0] === opt.id)
                          : false" @change="onOptionChange(q, opt.id, $event)" class="mr-2" />
                        <span class="mr-2 font-semibold">
                          {{ String.fromCharCode(97 + index) }}.
                        </span>
                        {{ opt.text }}

                        <textarea v-if="
                          answers[q.id] &&
                          (
                            (Array.isArray(answers[q.id]) && answers[q.id].includes(opt.id)) ||
                            answers[q.id] === opt.id
                          ) &&
                          opt.requires_text
                        " v-model="extraTexts" placeholder="Kerro lisää..." class="border p-2 w-full mt-2"
                          style="resize: none; width: 100%; height: 150px; display: block;"></textarea>
                      </label>

                    </div>
                  </div>

                  <p v-if="index == 6" class="arlainterface-regular font-18 mt-5">Kiitos, kun kerroit mielipiteesi, ja
                    olisi kiva, jos vastaisit vielä täydentäviin kysymyksiin ..Tsirp tsirp</p>

                </div>

                <div class="column is-12 has-text-centered">
                  <button class="button arla-button" :disabled="!isFormValid">Lähetä</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <ArlaFooter />
</template>

<script>
import ArlaNavbar from "../components/ArlaNavbar";
import ArlaFooter from "../components/ArlaFooter";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "QuestionnairePage",
  components: {
    ArlaNavbar,
    ArlaFooter,
  },
  data() {
    return {
      answers: {},
      extraTexts: '',
      selectedTown: ''
    }
  },
  methods: {
    ...mapActions({
      getQuestionnaire: "getQuestionnaire",
      postQuestionnaire: "postQuestionnaire",
      getSubmission: "getSubmission"
    }),
    ...mapGetters({
      getQuestionnaireData: "getQuestionnaireData"
    }),
    submitForm() {
      let payload = {
        email: this.$store.getters.getSubmissionEmail,
        user_uuid: this.$route.params.userUuid,
        answers: Object.entries(this.answers).map(([questionId, value]) => {
          const q = this.getQuestionnaireForm.questions.find(q => q.id == questionId)
          let selected = q.question_type === "multiple" ? (Array.isArray(value) ? value : [value]) : null
          if (q.text == 'Asuinpaikka') {
            selected = [this.selectedTown]
          }

          const answerObj = {
            question: parseInt(questionId),
            boolean: q.question_type === "yesno" ? value === "true" : null,
            value: q.question_type === "scale" ? parseInt(value) : null,
            text: q.question_type === "text" ? value : null,
            selected_options: selected
          }

          if (selected != null) {
            if (selected.includes(30)) {
              answerObj.extra_texts = this.extraTexts
            }
          }

          return answerObj

        })
      }

      this.postQuestionnaire(payload).then(() => {
        this.$router.push({ path: `/questionnaire-thanks` })
      })
    },
    onOptionChange(q, optionId, event) {
      if (q.allows_multiple) {
        if (event.target.checked) {
          if (!this.answers[q.id].includes(optionId)) {
            this.answers[q.id].push(optionId)
          }
        } else {
          this.answers[q.id] = this.answers[q.id].filter(id => id !== optionId)
        }
      } else {
        this.answers[q.id] = [optionId]
      }
    }
  },
  async mounted() {
    await this.getSubmission(this.$route.params.userUuid)
    await this.getQuestionnaire()

    if (this.$store.getters.getIsSubmitted) {
      this.$router.push({ path: `/questionnaire-thanks` })
    }
    this.getQuestionnaireForm.questions.forEach(q => {
      if (q.question_type === 'multiple') {
        this.answers[q.id] = []
      }
      if (q.question_type === 'multiple' && q.text === 'Asuinpaikka') {
        this.answers[q.id] = ""
      }
    })
  },
  computed: {
    getQuestionnaireForm() {
      if (this.getQuestionnaireData() != null) {
        return this.getQuestionnaireData()
      } else {
        return { 'questions': [] }
      }
    },
    isFormValid() {
      const questions = this.getQuestionnaireForm.questions
      if (!questions.length) return false

      for (const q of questions) {
        const value = this.answers[q.id]

        if (!q.required) continue

        if (q.question_type === "yesno") {
          if (value === undefined) return false
          continue
        }

        if (q.question_type === "scale") {
          if (value === undefined || value === null) return false
          continue
        }

        if (q.question_type === "text") {
          if (!value || value.trim() === "") return false
          continue
        }

        if (q.question_type === "multiple") {
          // check required radio/dropdown has at least one option selected
          let arr = value
          if (arr?.toRaw) {
            arr = arr.toRaw()
          }
          if (!Array.isArray(arr)) {
            arr = []
          }
          if (arr.length === 0) return false
          continue
        }

        return false
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
@use "../assets/sass/mybulma" as *;

.do-good-page {
  flex: 1 1 auto;
}

.hero-body {
  background-color: #F6F1D3;
}

#arla-product-question-picture {
  img {
    width: 200px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>